export const calcSideHolePos = (el, side, detailData, scale, xPos, yPos, x, y, radius = 0) => {
    let scaleRadius
    let scaleX
    let scaleY
    let nameX
    let nameY

    const xWidthDirection = side === "RIGHT" ? -1 : 1
    const yWidthDirection = side === "BACK" ? -1 : 1

    if (side === 'LEFT' || side === 'RIGHT') {
        scaleRadius = x * radius / detailData.height
        scaleX = (x * el.z / detailData.height - x / 2) * xWidthDirection
        scaleY = el.y * scale - yPos
        nameX = el.z
        nameY = el.y

    } else {
        scaleRadius = y * radius / detailData.height
        scaleX = el.x * scale - xPos
        scaleY = (y * el.z / detailData.height - y / 2) * yWidthDirection
        nameX = el.x
        nameY = el.z
    }

    return {scaleRadius, scaleX, scaleY, nameX, nameY}
}
